var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03 8.32a.203.203 0 00.075-.012l3.858-1.131.114 2.77-.947.596a.271.271 0 00-.127.23v.953c0 .141.132.274.272.274a.337.337 0 00.066-.009l1.556-.393 1.557.393a.337.337 0 00.065.009c.14 0 .272-.128.272-.274v-.954a.271.271 0 00-.127-.23l-.947-.596.114-2.769 3.858 1.13c.163.05.347-.092.347-.26V6.82a.271.271 0 00-.127-.23L6.985 4.086l.127-2.57v-.013a1.7 1.7 0 00-.333-.976C6.572.243 6.269 0 5.893 0c-.377 0-.68.238-.886.526a1.69 1.69 0 00-.333.976v.013l.127 2.57L.877 6.59a.271.271 0 00-.127.23v1.227c.009.146.158.274.28.274z",
    fill: "#0B69E3"
  })));
}
export default SvgFlightIcon;